import {
    Box,
    Typography,
    Dialog,
    DialogContent,
    IconButton,
    Link,
} from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { AndroidStoreIcon, AppStoreIcon } from '../../../shared/ui/Icons'
import { useMobileAppContent } from '@/shared/hooks'

const MobileAppContent: React.FC = () => {
    const { t: translate } = useTranslation()
    const { userUseIOS, userUseAndroid } = useMobileAppContent()
    const [open, setOpen] = useState(true)

    const imageContainer = {
        display: 'flex',
        gap: '16px',
        justifyContent: 'center',

        'a > svg': {
            mt: '20px',
            width: '60%',
            transition: 'transform 0.2s ease-in-out',
            '&:hover': {
                transform: 'scale(1.05)',
            },
        },
    }

    return (
        <Dialog
            open={open}
            onClose={() => setOpen(false)}
            fullWidth
            PaperProps={{
                sx: {
                    width: 'auto',
                    backgroundColor: 'rgba(0,0,0,0.85)',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    margin: '0',
                },
            }}>
            <DialogContent
                sx={{
                    position: 'relative',
                    padding: '40px',
                    backgroundColor: 'custom.dropDownBackground',
                    textAlign: 'center',
                    boxShadow: 24,
                    minWidth: { xs: '80%', sm: '400px' },
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                }}>
                <IconButton
                    aria-label="close"
                    onClick={() => setOpen(false)}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}>
                    <CloseIcon />
                </IconButton>

                <Typography variant="body1" sx={{ color: '#fff' }} gutterBottom>
                    {translate('downloadAppStatement')}
                </Typography>

                <Box sx={imageContainer}>
                    {userUseAndroid && (
                        <Link
                            href="https://play.google.com/store/apps/details?id=pl.net.toya.dottv"
                            target="_blank">
                            <AndroidStoreIcon />
                        </Link>
                    )}
                    {userUseIOS && (
                        <Link
                            href="https://apps.apple.com/pl/app/toya-go-new/id6738382647?l=pl"
                            target="_blank">
                            <AppStoreIcon />
                        </Link>
                    )}
                </Box>

                <Typography
                    variant="body1"
                    sx={{ mt: '10px', color: '#fff' }}
                    gutterBottom>
                    {translate('noAccountRegisterEboa')}{' '}
                    <Link href="eboa.toya.net.pl">
                        <span>eboa.toya.net.pl</span>
                    </Link>
                </Typography>
            </DialogContent>
        </Dialog>
    )
}

export { MobileAppContent }
